import { render, staticRenderFns } from "./list-table-tab.vue?vue&type=template&id=e2a8e082"
import script from "./list-table-tab.vue?vue&type=script&lang=js"
export * from "./list-table-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports